import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout.js";
import { apiFetch } from "../../api.js";
import Select from "react-select";

const ChequeReceiptDetailsDesign = () => {
  const navigate = useNavigate();
  const [ChequeNo, setChequeNo] = useState("");
  const [ChequeNoList, setChequeNoList] = useState([]);
  const [Receiptno, setReceiptno] = useState("");
  const [ReceiptNoList, setReceiptNoList] = useState([]);
  const [ChequeDate, setChequeDate] = useState("");
  const [DepositDate, setDepositDate] = useState("Deposit");
  const [CustomerName, setCustomerName] = useState("");
  const [Amount, setAmount] = useState("");
  const [BankName, setBankName] = useState("");
  const [ChequeStatus, setChequeStatus] = useState("");
  const [OwnerBank, setOwnerBank] = useState("");
  const [OwnerBankList, setOwnerBankList] = useState([]);
  const [isEditMode] = useState(false);
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: "45px",
      height: "45px",
      borderRadius: "6px",
      borderColor: "#ccc",
      boxShadow: "none",
      fontSize: "14px",
    }),
    valueContainer: (base) => ({
      ...base,
      height: "45px",
      padding: "0 12px",
      display: "flex",
      alignItems: "center",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "45px",
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };
  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "14px",
    flexWrap: "nowrap", // 🔥 no wrapping (forces one row)
    width: "100%",
    marginTop: "30px",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px",
    height: "44px",
    padding: "0 18px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
  });
  //--------------CHEQUE RECEIPT EXIT CODE
  const handleExit = () => {
    navigate("/dashboard");
  };
  //--------------CHEQUE RECEIPT USEEFFECT CODE
  useEffect(() => {
    loadChequeNo();
    loadReceiptNo();
    loadOwnerBank();
  }, []);

  useEffect(() => {
    if (ChequeNo) {
      loadChequeDetails(ChequeNo);
    } else {
      clearAutoFields();
    }
  }, [ChequeNo]);

  useEffect(() => {
    if (Receiptno) {
      loadReceiptDetails(Receiptno);
    }
  }, [Receiptno]);

  //--------------CHEQUE RECEIPT CHEQUE NO
  const loadChequeNo = async () => {
    try {
      const response = await apiFetch(
        "/api/receipt/chequeno",
        { method: "POST", body: JSON.stringify({}) },
      );
      const data = await response.json();
      if (data.err === "0") {
        setChequeNoList(data.list.map((x) => ({ value: x.data, label: x.value })));
      }
    } catch (err) {
      console.error("❌ Cheque No API error:", err);
    }
  };
  //--------------CHEQUE RECEIPT RECEIPT NO
  const loadReceiptNo = async () => {
    try {
      const response = await apiFetch(
        "/api/receipt/receipt-no",
        { method: "POST", body: JSON.stringify({}) },
      );
      const data = await response.json();
      if (data.err === "0") {
        setReceiptNoList(data.list.map((x) => ({ value: x.data, label: x.value })));
      }
    } catch (err) {
      console.error("❌ Receipt No API error:", err);
    }
  };
  //--------------CHEQUE RECEIPT OWNER BANK
  const loadOwnerBank = async () => {
    try {
      const response = await apiFetch(
        "/api/receipt/ownbank",
        { method: "POST", body: JSON.stringify({}) },
      );
      const data = await response.json();
      if (data.err === "0") {
        setOwnerBankList(data.list.map((x) => ({ value: x.data, label: x.value })));
      }
    } catch (err) {
      console.error("❌ Owner Bank API error:", err);
    }
  };
  //--------------CHEQUE RECEIPT CHEQUE NO SELECTION ALL FIELDS FILL
  const loadChequeDetails = async (rcl_2) => {
    const response = await apiFetch(
      "/api/receipt/custname",
      { method: "POST", body: JSON.stringify({ rcl_2 }) },
    );
    const data = await response.json();
    if (data.err === "0" && data.data) {
      const d = data.data;
      setCustomerName(d.custname || "");
      setAmount(d.amount || "");
      setBankName(d.bankname || d.chqbank || d.bank_name || d.bank || "");
      setReceiptno(d.rcl_2);
      setChequeDate(formatDate(d.date));
    }
  };
  const clearAutoFields = () => {
    setCustomerName("");
    setAmount("");
    setBankName("");
    setReceiptno("");
    setChequeDate("");
    setChequeStatus("Deposit");
  };
  //--------------CHEQUE RECEIPT DATE FORMAT CORRECTION
  const formatDate = (ddmmyyyy) => {
    if (!ddmmyyyy) return "";
    const [dd, mm, yyyy] = ddmmyyyy.split("/");
    return `${yyyy}-${mm}-${dd}`;
  };
  //--------------CHEQUE RECEIPT RECEIPT NO SELECTION ALL DETAILS FILL
  const loadReceiptDetails = async (rcl_2) => {
    try {
      const response = await apiFetch(
        "/api/receipt/custname-by-rno",
        { method: "POST", body: JSON.stringify({ rcl_2 }) },
      );
      const data = await response.json();
      if (data.err === "0" && data.data) {
        const d = data.data;
        setCustomerName(d.custname || "");
        setAmount(d.amount || "");
        setBankName(d.bankname || d.chqbank || d.bank_name || d.bank || "");
        setChequeDate(formatDate(d.date));
        setChequeNo(d.rcl_2);
      }
    } catch (err) {
      console.error("❌ Receipt detail fetch error:", err);
    }
  };
  //--------------CHEQUE RECEIPT SAVE
  const handleSave = async () => {
    try {
      const payload = {
        Rcl_2: ChequeNo,
        Rcl_107: ChequeStatus,
        Rcl_108: DepositDate,
        Rcl_109: OwnerBank,
        Rcl_111: null,
        Rcl_112: null,
      };
      const response = await apiFetch(
        "/api/receipt/chqclear",
        { method: "POST", body: JSON.stringify(payload) },
      );
      const data = await response.json();
      if (data.err === "0") {
        alert(data.msg);
      } else {
        alert("Save failed");
      }
      navigate("/dashboard");
    } catch (err) {
      console.error("❌ Save Error:", err);
      alert("Server error");
    }
  };

  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div className="header">Cheque Deposit Entry</div>

          {/* ================= FORM RO 1 ================= */}
          <div className="form-row">
            <div className="form-column">
              <label>Cheque No</label>
              <Select
                options={ChequeNoList}
                value={ChequeNoList.find((o) => o.value === ChequeNo) || null}
                onChange={(selected) => setChequeNo(selected?.value || "")}
                styles={customStyles}
                placeholder="Select Cheque No"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            <div className="form-column">
              <label>Receipt No</label>
              <Select
                options={ReceiptNoList}
                value={ReceiptNoList.find((o) => o.value === Receiptno) || null}
                onChange={(selected) => setReceiptno(selected?.value || "")}
                styles={customStyles}
                placeholder="Select Receipt No"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>

            <div className="form-column">
              <label>Customer Name</label>
              <input className="common-input" value={CustomerName} disabled />
            </div>
            <div className="form-column">
              <label>Cheque Date</label>
              <input
                type="date"
                className="common-input"
                value={ChequeDate}
                disabled
              />
            </div>
          </div>
          {/* ================= FORM RO 2 ================= */}
          <div className="form-row">
            <div className="form-column">
              <label>Amount</label>
              <input className="common-input" value={Amount} disabled />
            </div>

            <div className="form-column">
              <label>Bank</label>
              <input className="common-input" value={BankName} disabled />
            </div>

            <div className="form-column">
              <label>Cheque Status</label>
              <select
                className="common-select"
                value={ChequeStatus}
                onChange={(e) => setChequeStatus(e.target.value)}
              >
                <option value="Deposit">Deposit</option>
                <option value="Clear">Clear</option>
                <option value="Not-Clear">Not-Clear</option>
                <option value="Bounce">Bounce</option>
              </select>
            </div>

            <div className="form-column">
              <label>Deposit Date</label>
              <input
                type="date"
                className="common-input"
                value={DepositDate}
                onChange={(e) => setDepositDate(e.target.value)}
              />
            </div>
          </div>
          {/* ================= FORM RO 3 ================= */}
          <div className="form-row">
            <div className="form-column">
              <label>Owner's Bank</label>
              <Select
                options={OwnerBankList}
                value={OwnerBankList.find((o) => o.value === OwnerBank) || null}
                onChange={(selected) => setOwnerBank(selected?.value || "")}
                styles={customStyles}
                placeholder="Select Owner Bank"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
            <div className="form-column"></div>
            <div className="form-column"></div>
            <div className="form-column"></div>
          </div>

          {/* ================= BUTTONS ================= */}
          <div style={buttonContainerStyle}>
            <button style={buttonStyle("#4caf50")} onClick={handleSave}>
              Save
            </button>

            {isEditMode && <button className="btn-update">Update</button>}
            <button style={buttonStyle("#ab2025")} onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>

      {/* ================= STYLES ================= */}
      <style>{`
   .rs__menu-portal {
  z-index: 9999 !important;
}

/* ================= PAGE ================= */

.page-container {
  min-height: 100vh;
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  padding: 10px;
}

.container {
  width: 100%;
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 4px 8px rgba(0,0,0,.1);
}

/* ================= HEADER ================= */

.header {
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  padding: 14px;
  background: #8b1e3f;
  color: #fff;
  border-radius: 6px;
  margin-bottom: 20px;
}

/* ================= GRID SYSTEM ================= */

/* Desktop default → 4 columns */
.form-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 16px;
}

.form-column {
  display: flex;
  flex-direction: column;
}

/* Laptop → 3 */
@media (max-width: 1400px) {
  .form-row {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* iPad → 2 */
@media (max-width: 1024px) {
  .form-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mobile → 1 */
@media (max-width: 768px) {
  .form-row {
    grid-template-columns: 1fr;
  }
}

/* ================= INPUTS ================= */

label {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 4px;
}

.common-input,
.common-select {
  height: 45px;
  padding: 10px 14px;
  border-radius: 6px;
  border: 1px solid #cfcfcf;
  font-size: 14px;
  width: 100%;
}

.common-input:focus,
.common-select:focus {
  outline: none;
  border-color: #8b1e3f;
  box-shadow: 0 0 0 1px rgba(139,30,63,.25);
}

.common-select {
  appearance: none;
  background-image: url("data:image/svg+xml;utf8,<svg fill='%23999' height='20' viewBox='0 0 24 24' width='20' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 18px;
  padding-right: 36px;
}

/* ================= BUTTON CENTER SYSTEM ================= */

.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;
  margin-top: 24px;
  width: 100%;
  flex-wrap: nowrap;
}

.button-container button {
  min-width: 120px;
  height: 42px;
  border: none;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
  white-space: nowrap;
}

/* Keep ONE ROW on mobile also */
@media (max-width: 768px) {
  .button-container {
    flex-direction: row;
  }

  .button-container button {
    min-width: 100px;
  }
}

.btn-save {
  background: #4caf50;
  color: #fff;
}

.btn-update {
  background: #2e20ab;
  color: #fff;
}

.btn-exit {
  background: #ab2025;
  color: #fff;
}

/* ================= REACT SELECT MATCH ================= */

.rs__control {
  min-height: 45px !important;
  height: 45px !important;
  border-radius: 6px !important;
  border-color: #ccc !important;
  box-shadow: none !important;
}

.rs__value-container {
  height: 45px !important;
  padding: 0 12px !important;
  display: flex;
  align-items: center;
}

.rs__indicators {
  height: 45px !important;
}

.rs__indicator-separator {
  display: none;
}

      `}</style>
    </Layout>
  );
};

export default ChequeReceiptDetailsDesign;
